




























import Vue, { PropType } from "vue";

import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import { getGraduateYearColorInCompany } from "@/helpers/company-detail-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ChartLegend",
  components: {
    Heading,
    Checkbox
  },
  model: {
    prop: "selectedYears",
    event: "changeSelectedYears"
  },
  props: {
    latestYear: {
      type: Number as PropType<Props["latestYear"]>,
      required: true
    },
    selectedYears: {
      type: Array as PropType<Props["selectedYears"]>,
      required: true
    },
    disabled: {
      type: Boolean as PropType<Props["disabled"]>,
      default: false
    }
  },
  computed: {
    yearItems() {
      const yearCount = 3;
      return [...Array(yearCount)]
        .map((_, i) => {
          const graduateYear = this.latestYear - i;
          return {
            graduateYear,
            slicedGraduateYear: String(graduateYear).slice(-2),
            checked: this.selectedYears.some(
              selectedYear => selectedYear === graduateYear
            ),
            colorType: getGraduateYearColorInCompany(
              this.latestYear,
              graduateYear
            ).type
          };
        })
        .reverse();
    }
  },
  methods: {
    clickCheckbox(yearItem) {
      let nextSelectedYears: Props["selectedYears"];
      if (
        this.selectedYears.some(
          selectedYear => selectedYear === yearItem.graduateYear
        )
      ) {
        nextSelectedYears = this.selectedYears.filter(
          selectedYear => selectedYear !== yearItem.graduateYear
        );
      } else {
        nextSelectedYears = [...this.selectedYears, yearItem.graduateYear];
      }
      this.$emit("changeSelectedYears", nextSelectedYears);
    }
  }
});
